import { useState } from "react";
import { StandardPanel } from '../../../_components/panel/standard.panel';
import { TicketActionList } from './ticket-actionList';

export function TicketActionPanel() {

    const [isLoading, setIsLoading] = useState(false);
    return (
        <>
            <StandardPanel
                title="Actions"
                buttons={[
                   // { icon: "edit", onClick: () => { navigate("ManageActions/Update") } },
                    // { icon: "delete", variant: "error", onClick: () => { disable(item.id) } },
                ]}
                loading={isLoading}>

                <TicketActionList />
            </StandardPanel>
           
        </>
    );

}
